import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { Redirect, withRouter } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Title from "../components/Title";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import { getFilteredMerchants } from "../store/CloudActions";
import DashboardSideMenu from "../components/DashboardSideMenu/DashboardSideMenu";
import { getGeneralRoutes } from "../utils/routes/Routes";
import { Pagination } from "@material-ui/lab";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

const columns = [
  { id: "name", label: "Name", minWidth: 200 },
  { id: "active", label: "Takeaway / Delivery Open" },
  { label: "Ta" },
  { label: "Sp" },
];

function SelectLocation(props) {
  const classes = useStyles();
  const [logout, setLogout] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [searchValue, setSearchValue] = React.useState(localStorage.getItem("select_location_search_value") ?? "");
  const [filteredMerchants, setFilteredMerchants] = React.useState(null);
  const [merchantsRows, setMerchantRows] = React.useState(null);
  const [pages, setPages] = React.useState(1);

  const merchantsPerPage = 10;

  function onChange() {
    let filteredMerchants = cloudStore.filteredMerchants ?? [];
    setFilteredMerchants(filteredMerchants);
    setPages(filteredMerchants.length);

    if (localStorage.getItem("mynoberPage")) {
      setPage(parseInt(localStorage.getItem("mynoberPage")));
    }
  }

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED, onChange);
    if (cloudStore.merchants === null) {
      getFilteredMerchants();
    } else {
      onChange();
    }
    return () => cloudStore.removeListener(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED, onChange);
  }, []);

  useEffect(() => {
    let temp =
      cloudStore.merchants?.filter((row) => {
        if (
          cloudStore.userRoles &&
          (cloudStore.userRoles.includes("superadmin") || cloudStore.userRoles.includes("admin"))
        ) {
          if (row.name && row.name.toLowerCase().includes(searchValue.toLowerCase())) {
            return true;
          }
          if (row.merchantId != null && row.merchantId.toString().includes(searchValue)) {
            return true;
          }
          if (
            row.ta_merchants &&
            row.ta_merchants.some((taMerchant) => taMerchant.id.toString().includes(searchValue))
          ) {
            return true;
          }
          if (
            row.sp_merchants &&
            row.sp_merchants.some((spMerchant) => spMerchant.id.toString().includes(searchValue))
          ) {
            return true;
          }
        }
        if (row.name) {
          return row.name.toLowerCase().includes(searchValue.toLowerCase());
        }
        return false;
      }) ?? [];
    let oldLength = temp.length;
    localStorage.setItem("filteredArray", JSON.stringify(temp));
    if (temp.length % merchantsPerPage !== 0) {
      while (temp.length % merchantsPerPage !== 0) {
        temp.push({});
      }
    }

    setPages(oldLength);
    setMerchantRows(temp);
  }, [searchValue, filteredMerchants]);

  if (merchantsRows === null) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    localStorage.setItem("mynoberPage", newPage);
  };

  const handleEmptySearchVal = () => {
    localStorage.setItem("select_location_search_value", "");
    setSearchValue("");
    localStorage.setItem("filteredArray", JSON.stringify(cloudStore.merchants));
    setPages(cloudStore.merchants.length);
    setMerchantRows(cloudStore.merchants);
    setPage(1);
    localStorage.setItem("mynoberPage", 1);
  };

  const handleSearch = (event) => {
    setPage(1);
    localStorage.setItem("mynoberPage", 1);
    localStorage.setItem("select_location_search_value", event.target.value);
    setSearchValue(event.target.value);
  };

  if (logout === true) {
    return <Redirect to="/login" />;
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <DashboardSideMenu routes={getGeneralRoutes()} />

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container>
            <Grid item xs={10}>
              <Title>Locations</Title>
            </Grid>
            <Grid item xs={2}>
              <TextField
                value={searchValue}
                onChange={handleSearch}
                size="small"
                label="Search"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchValue.length > 0 ? <ClearIcon onClick={handleEmptySearchVal} /> : null}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Paper className={classes.root}>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {merchantsRows
                    .slice((page - 1) * merchantsPerPage, page * merchantsPerPage)
                    .map((merchant, index) => {
                      return (
                        <TableRow
                          style={{ height: 50, padding: 10 }}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={merchant.merchant_id}
                          onClick={() => {
                            if (merchant.merchant_id) {
                              props.history.push("/home/" + merchant.merchant_id + "/articles/articles");
                            }
                          }}
                        >
                          <TableCell style={{ height: 50, padding: 10 }} key={merchant.merchant_id}>
                            {merchant.name}
                          </TableCell>
                          <TableCell style={{ height: 50, padding: 10 }}>
                            {merchant.ta_active && (
                              <div
                                style={{
                                  display: "inline-block",
                                  backgroundColor: merchant.ta_active,
                                  borderRadius: "50%",
                                  width: 20,
                                  height: 20,
                                }}
                              />
                            )}
                          </TableCell>

                          {
                            <TableCell style={{ height: 50, padding: 10 }}>
                              {merchant.ta_merchants &&
                                merchant.ta_merchants.map((taMerchant) => (
                                  <span key={taMerchant.id}>{taMerchant.id},</span>
                                ))}
                            </TableCell>
                          }

                          {
                            <TableCell style={{ height: 50, padding: 10 }}>
                              {merchant.sp_merchants &&
                                merchant.sp_merchants.map((spMerchant) => (
                                  <span key={spMerchant.id}>{spMerchant.id},</span>
                                ))}
                            </TableCell>
                          }
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
              <Pagination
                color={"primary"}
                count={Math.ceil(pages / merchantsPerPage)}
                page={page}
                showFirstButton={true}
                showLastButton={true}
                onChange={handleChangePage}
              />
            </TableContainer>
          </Paper>
        </Container>
      </main>
    </div>
  );
}

export default withRouter(SelectLocation);
